module.exports = __webpack_public_path__ + "mo/img/loading.942c9707.svg";